import dayjs from 'dayjs';
import { maskJs } from 'mask-js';
export const OpemUrl = url => url ? window.open(item, '_blank') : '';
export const FormatMonth = date => date ? dayjs(date).format('MM/YYYY') : "";
export const FormatDate = date => date ? dayjs(date).format('DD/MM/YYYY') : "";
export const FormatDateShort = date => date ? dayjs(date).format('DD/MM/YY') : "";
export const FormatDateTime = date => date ? dayjs(date).format('DD/MM/YYYY HH:mm') : "";
export const FormatDateTimeShort = date => date ? dayjs(date).format('DD/MM HH:mm') : "";
export const FormatZipcode = v => v ? maskJs('99999-999', v) : '';
export const FormatCpf = cpf => cpf ? maskJs('999.999.999-99', cpf) : '';
export const FormatCnpj = cnpj => cnpj ? maskJs('99.999.999/9999-99', cnpj) : '';
export const FormatPhone = phone => phone ? maskJs('(99) 9999?9-9999', phone) : '';
export const FormatMoneyOlD = v => {
	let val = (v / 1).toFixed(2).replace('.', ',')
	return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
}



export const FormatMoney = (v) => {
	const numero = Number(v);
	if (isNaN(numero)) return "0,00";

	// Transforma em string com 2 casas decimais e separa inteiro dos centavos
	let partes = numero.toFixed(2).split('.');

	// Aplica o regex de milhar apenas na parte inteira
	partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");

	// Junta tudo com a vírgula
	return partes.join(',');
};
export const FormatStatus = v => {
	switch (v) {
		case 'pending': return 'Pendente'; break;
		case 'approved': return 'Aprovado'; break;
		case 'rejected': return 'Rejeitado'; break;
	}

}

export const FormatPaymentMethod = v => {
	switch (v) {
		case 1: return 'Dinheiro'; break;
		case 2: return 'Pix'; break;
		case 3: return 'Cartão Débito'; break;
		case 4: return 'Cartão Crédito'; break;
		case 5: return 'Outro'; break;
	}
}


export const Situations = [
	// {value: 1, text: `Em dia`, color: `#000000`},
	{ value: 2, text: `Finalizado`, color: `#CBEFCB` },
	{ value: 3, text: `Risco`, color: `#CBEFCB` },
	{ value: 4, text: `Atenção`, color: `#ffc97d` },
	{ value: 5, text: `Crítico`, color: `#FF0000` },
	{ value: 6, text: `Acordo`, color: `#ffe1ff` },
	{ value: 7, text: `Judicial`, color: `#df9fff` },
	{ value: 8, text: `Bloqueado`, color: `#000` },
	// {value: 9, text: `⁠Vencido`, color: `#FF9595`},
];



export const FormatSituations = v => {
	switch (v) {
		case 1: return 'Em dia'; break;
		case 2: return 'Finalizado'; break;
		case 3: return 'Risco'; break;
		case 4: return 'Atenção'; break;
		case 5: return 'Crítico'; break;
		case 6: return 'Acordo'; break;
		case 7: return 'Judicial'; break;
		case 8: return 'Bloqueado'; break;
		case 9: return '⁠Vencido'; break;
		default: return 'Em dia'; break;
	}
}

export const FormatSituationsText = v => {
	switch (v) {
		case 1: return 'Em dia'; break;
		case 2: return 'Finalizado'; break;
		case 3: return 'Risco'; break;
		case 4: return 'Atenção'; break;
		case 5: return 'Crítico'; break;
		case 6: return 'Acordo'; break;
		case 7: return 'Judicial'; break;
		case 8: return 'Bloqueado'; break;
		case 9: return '⁠Vencido'; break;
		default: return 'Em dia'; break;
	}
}


export const FormatSituationsColor = v => {
	switch (v) {
		case 1: return '#000000'; break; // Cinza Escuro (Para contraste e neutro)
		case 2: return '#CBEFCB'; break; // Verde Menta Pastel
		case 3: return '#FFF59D'; break; // Amarelo Pálido/Claro
		case 4: return '#ffc97d'; break; // Laranja Pêssego Suave
		case 5: return '#FF0000'; break; // Salmão Pastel (Vermelho suave)
		case 6: return '#E4D2E2'; break; // Lilás Claro
		case 7: return '#C2C8F8'; break; // Lavanda Suave (Um pouco mais distinto do case 6)
		case 8: return '#000'; break; // Azul-Acinzentado Claro (Novo neutro/frio)
		case 9: return '#FF9595'; break; // Azul Céu Pastel (Para um azul suave)
		default: return '#000'; break; // Cor de fallback
	}
}

export const FormatSituationsTextColor = v => {
	switch (v) {
		case 1: return 'text-situation-1'; break; // Cinza Escuro (Para contraste e neutro)
		case 2: return 'text-situation-2'; break; // Verde Menta Pastel
		case 3: return 'text-situation-3'; break; // Amarelo Pálido/Claro
		case 4: return 'text-situation-4'; break; // Laranja Pêssego Suave
		case 5: return 'text-situation-5'; break; // Salmão Pastel (Vermelho suave)
		case 6: return 'text-situation-6'; break; // Lilás Claro
		case 7: return 'text-situation-7'; break; // Lavanda Suave (Um pouco mais distinto do case 6)
		case 8: return 'text-situation-8'; break; // Azul-Acinzentado Claro (Novo neutro/frio)
		case 9: return 'text-situation-9'; break; // Azul Céu Pastel (Para um azul suave)
		default: return 'text-situation-default'; break; // Cor de fallback
	}
}


export const Status = [
	{ value: 1, text: `À vencer`, color: `#D5E6F8` },
	{ value: 2, text: `⁠Vencido`, color: `#ff7787` },
	{ value: 3, text: `Parcial`, color: `#e2e371` },
	{ value: 4, text: `⁠Pago`, color: `#CBEFCB` },

];

export const FormatIntStatusText = v => {
	switch (v) {
		case 1: return `À vencer`; break;
		case 2: return `⁠Vencido`; break;
		case 3: return `Parcial`; break;
		case 4: return `⁠Pago`; break;
	}
}

export const FormatIntStatusColor = v => {
	switch (v) {
		case 1: return '#D5E6F8'; // Azul Ardósia Suave
		case 2: return '#ff7787'; // Vermelho Tijolo Desbotado
		case 3: return '#e2e371'; // Ouro Velho Suave
		case 4: return '#CBEFCB'; // Verde Oliva Desbotado
	}
}

export const FormatIntStatusTextColor = v => {
	switch (v) {
		case 1: return 'text-status-1'; // Azul Ardósia Suave
		case 2: return 'text-status-2'; // Vermelho Tijolo Desbotado
		case 3: return 'text-status-3'; // Ouro Velho Suave
		case 4: return 'text-status-4'; // Verde Oliva Desbotado
	}
}

// Status:'
// - À vencer: Azul (Automático, dentro do prazo de pagamento)
// - ⁠Vencido: Vermelho (Automático, excedeu o prazo de pagamento)
// - ⁠Pago: Verde (Automático, pagamento efetuado






export const FirstName = v => {
	var names = v.split(" ");
	return names[0];

}



function numeroPorExtenso(numero) {
	if (typeof numero !== 'number' || !Number.isInteger(numero)) {
		return numero.toString();
	}
	if (numero === 0) return "zero";

	const unidades = ["", "um", "dois", "três", "quatro", "cinco", "seis", "sete", "oito", "nove"];
	const especiais = ["dez", "onze", "doze", "treze", "catorze", "quinze", "dezesseis", "dezessete", "dezoito", "dezenove"];
	const dezenas = ["", "", "vinte", "trinta", "quarenta", "cinquenta", "sessenta", "setenta", "oitenta", "noventa"];
	const centenas = ["", "cem", "duzentos", "trezentos", "quatrocentos", "quinhentos", "seiscentos", "setecentos", "oitocentos", "novecentos"];
	const milhares = ["", "mil", "milhão", "bilhão", "trilhão"];

	let isNegativo = false;
	if (numero < 0) {
		isNegativo = true;
		numero = -numero;
	}

	let numeroStr = numero.toString();
	if (numeroStr.length === 0) return "";

	let extenso = [];

	// Preenche com zeros à esquerda para que o comprimento seja múltiplo de 3
	while (numeroStr.length % 3 !== 0) numeroStr = '0' + numeroStr;

	const grupos = numeroStr.match(/.{1,3}/g);

	if (grupos) {
		for (let j = grupos.length - 1; j >= 0; j--) {
			const grupo = parseInt(grupos[j]);
			if (grupo === 0) continue;

			// ---- CORREÇÃO 1: Calcular o índice 'i' dinamicamente ----
			// Em vez de i++, calculamos o índice da classe (0 para unidades, 1 para milhar, 2 para milhão, etc.)
			// com base na posição 'j' do grupo. Isso evita o erro do 'continue'.
			const i = (grupos.length - 1) - j;

			const c = Math.floor(grupo / 100);
			const d = Math.floor((grupo % 100) / 10);
			const u = grupo % 10;
			let parteExtenso = [];

			// ---- MELHORIA: Trata o caso de "mil" em vez de "um mil" ----
			if (i === 1 && grupo === 1) { // i === 1 é a classe dos milhares
				// Não adiciona "um", apenas o nome da classe.
			} else {
				if (c > 0) {
					// Simplificado para usar o array de centenas diretamente
					parteExtenso.push(centenas[c]);
				}

				if (d > 0 || u > 0) {
					if (c > 0 && (d > 0 || u > 0)) parteExtenso.push("e");
					if (d === 1) {
						parteExtenso.push(especiais[u]);
					} else {
						if (d > 1) parteExtenso.push(dezenas[d]);
						if (u > 0) {
							if (d > 1) parteExtenso.push("e");
							parteExtenso.push(unidades[u]);
						}
					}
				}
			}

			if (i > 0 && milhares[i]) {
				// Ajusta para o plural (ex: milhões)
				const termo = (grupo > 1) ? milhares[i].replace('ão', 'ões') : milhares[i];
				parteExtenso.push(termo);
			}
			extenso.unshift(parteExtenso.join(" "));
		}
	}

	// Junta os grupos. Ex: ["mil", "cem", "e um"]
	let resultadoFinal = extenso.join(" ").trim();
	// Limpa espaços duplos que podem surgir
	resultadoFinal = resultadoFinal.replace(/\s\s+/g, ' ');
	// Junta grupos com "e" (ex: "um milhão e cem mil")
	resultadoFinal = resultadoFinal.replace(/(\smil\s|\smilhão\s|\smilhões\s)/g, '$1e ');
	// Remove "e" redundante no final, se houver
	if (resultadoFinal.endsWith('e ')) {
		resultadoFinal = resultadoFinal.slice(0, -2);
	}


	// ---- CORREÇÃO 2: Remove as substituições desnecessárias ----
	// A lógica acima já trata o caso "mil", então estas linhas não são mais necessárias.
	// resultadoFinal = resultadoFinal.replace(/\s+e\s+mil\b/, " mil");
	// resultadoFinal = resultadoFinal.replace(/^um mil\b/, 'mil');

	return isNegativo ? "menos " + resultadoFinal : resultadoFinal;
}


/**
 * Função principal para converter um número para o formato por extenso
 * sem as unidades monetárias (ideal para cheques).
 */
export const NumberInFull = numero => {
	if (typeof numero !== 'number') {
		return "Por favor, forneça um número válido.";
	}

	// Arredonda o número para duas casas decimais
	const numeroArredondado = parseFloat(numero.toFixed(2));

	const [parteInteiraStr, parteDecimalStr] = numeroArredondado.toString().split('.');

	const parteInteira = parseInt(parteInteiraStr, 10);
	const parteDecimal = parseInt((parteDecimalStr || "0").padEnd(2, '0'), 10);

	// Converte a parte inteira
	const extensoInteiro = numeroPorExtenso(parteInteira);

	// Se não houver parte decimal, retorna apenas a parte inteira por extenso
	if (parteDecimal === 0) {
		return extensoInteiro;
	}

	// Converte a parte decimal
	const extensoDecimal = numeroPorExtenso(parteDecimal);

	// Junta a parte inteira e a decimal com "e"
	return `${extensoInteiro} e ${extensoDecimal}`;
}
